<template>
	<div class="head mb-2">
		<div class="p-3">Skill Assessment</div>
		<hr class="m-0" />
	</div>
	<div class="columns container mb-4">
		<div class="column is-full-mobile is-half-desktop">
			<div class="quiz-image mb-4">
				<dynamic-image :image="quizImage"></dynamic-image>
			</div>
			<div class="is-full">
				<div >
					<div class="has-text-centered bold-text is-size-5 mb-5">Skill Assessment Attempts Exceeded</div>
					<div class="has-text-centered mb-4">
						You've reached the maximum number of attempts for this skills assessment.
					</div>
					<quiz-failed-details></quiz-failed-details>
				</div>
			</div>
		</div>
		<quiz-info></quiz-info>
	</div>

	<br />
	<br />
	<br />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { STATE_MODULES } from '@/store/state-modules';
import { QuizGetters } from '@/store/modules/quiz/getters';
import QuizInfo from '../helpers/QuizInfo.vue';
import QuizFailedDetails from '../helpers/QuizFailedDetails.vue';
import DynamicImage from '@/components/ui/hoc/DynamicImage.vue'

export default defineComponent({
	computed: {
		...mapGetters(STATE_MODULES.QUIZ, {
			quizImage: QuizGetters.GET_QUIZ_IMAGE,
			quizTime: QuizGetters.GET_QUIZ_TIME,
			questionsPerQuiz: QuizGetters.GET_QUESTIONS_COUNT,
			quizName: QuizGetters.GET_QUIZ_NAME
		})
	},
	components: {
		QuizInfo, QuizFailedDetails, DynamicImage
	}
})
</script>

<style scoped>
	.head hr {
		background: #d4d4d4;
	}

	.container{
		max-width: 1000px;
		margin: 0 auto;
	}

	.info-item{
		display: inline-block;
		border: 2px solid;
		min-width: 100px;
	}
	.info-item img {
		height: 25px;;
	}

	.disclaimer{
		color: #B5B6BA;
	}

	.cta{
		max-width: 500px;
		margin: 0 auto;
	}
</style>
